module.exports = __webpack_public_path__ + "media/images/application/template/logo-google-reviews-66d3d48a257a5bc6dbfeb691414a9412.svg";